import { render, staticRenderFns } from "./SuperAdminBarChart.vue?vue&type=template&id=50e0b4aa"
import script from "./SuperAdminBarChart.vue?vue&type=script&lang=js"
export * from "./SuperAdminBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports